import { createActionType } from "helpers/reduxHelpers";

export const LOGIN = createActionType("LOGIN");
export const LOGOUT = createActionType("LOGOUT");
